import { MiBox, MiList } from "@miplatform/components";
import { PAGINATION } from "@miplatform/constants";
import { useRouter } from "@miplatform/hooks";

export function CommunitiesTab({
  isLoading,
  communities,
  setCommunities,
  getCommunities,
}) {
  const { navigate } = useRouter();

  const sections = [
    {
      fieldset: [
        {
          label: "Community",
          field: "name",
        },
        {
          label: "State",
          field: "regionCode",
        },
        {
          label: "City",
          field: "city",
        },
        {
          label: "Latitude",
          field: "location",
          renderValue: ({ location }) => location.Latitude.toFixed(6) || "",
        },
        {
          label: "Longitude",
          field: "location",
          renderValue: ({ location }) => location.Longitude.toFixed(6) || "",
        },
        {
          label: "Total Homes",
          field: "totalCountOfHomes",
          value: "show", // when value is show, it will render the field.
        },
      ],
    },
  ];

  return (
    <MiBox height="inherit">
      <MiList
        viewType="card"
        cardProps={{
          sections,
          onClick: (item) => {
            navigate(`/communities/${item.id}`);
          },
          leftCardProps: { fieldset: [] },
        }}
        data={communities}
        loading={isLoading}
        setData={setCommunities}
        dataProvider={getCommunities}
        paginationMode={PAGINATION.SERVER}
        groupedMode
        groupedCriteria={(item) => item.builder.name}
      />
    </MiBox>
  );
}
